import { createContext, useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { getProfile } from '../services/project/userService';

const UserContext = createContext();

export const useUsers = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  
  const getUser = async () => {
    try {
      const parsedUser = JSON.parse(localStorage.getItem('user'));
      const user = await getProfile(parsedUser.id);
      setUser(user)
    } catch (error) {
      console.error('Failed to load user:', error);
      toast.error(error.response?.data?.errorMessage || 'Something went wrong');
    }
  };


  const permissions = user?.roles?.flatMap(role => {
    const perms = role?.permissions || {};
    return Object.entries(perms).flatMap(([section, actions]) =>
      actions.map(action => `${section}.${action}`)
    );
  }) || [];

  const hasPermission = (section, action = 'Read') => {
    if (permissions.length === 0) return true; // bypass if null, meaning admin
    return permissions.includes(`${section}.${action}`);
  }

  const isAdmin = user?.roles.some(role => role.regionIds == null);
  const isSuperAdmin = user?.roles.some(role => role.isSuper == true);

  useEffect(() => {
    getUser();
  }, []);

  return (
    <UserContext.Provider value={{ user, hasPermission, isAdmin, isSuperAdmin }}>
      {children}
    </UserContext.Provider>
  );
};
